import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../../../core/auth.service';
import { LoadingService } from '../../../../core/loading.service';
import { DialogService } from '../../../../core/dialog.service';
import { AlertService } from '../../../../core/alert.service';
import { UtilityService } from '../../../../core/utility.service';
import { TranslatorService } from '../../../../core/translator.service';
import { BaseService } from 'src/app/shared/base/base.service';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { Constants } from 'src/app/app.constants';
import { Badge } from 'src/app/inside-layout/routes/badges/badges.models'
import { Image } from 'src/app/shared/base/base.models';

@Component({
  selector: 'app-badges-form',
  templateUrl: './badges-form.component.html',
  styleUrls: ['./badges-form.component.scss']
})
export class BadgesFormComponent extends BaseFormComponent implements OnInit {
  public tabs: string[] = ['IMAGES'];
  constructor(
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService);
  }

  ngOnInit(): void {
    this.authorities.init('CD_CD', 'R_CD', 'U_CD', 'CD_CD');
    this.url = `${Constants.contextPath}/badges`;
    this.prepareFormData(new Badge(), (response: Badge) => {
      return this.modifyResponse(response);
    });
  }

  modifyResponse(response) {
    let image: Image = new Image();
    image.path = response.image;
    response.image = image;
    return response;
  }

  public modifyResult(response) {
    response.breadcrumbsId = response.mnemonic;
    let image: Image = new Image();
    image.path = response.image;
    response.image = image;
    return response;
  }

  public uploadFinishedEvent(event) {
    this.formData.image = event;
    this.saveChanges();
  }

  public deletedEvent(event) {
    if(event == this.formData.image) {
      this.formData.image = null;
      this.saveChanges();
    }
  }

  public saveChanges(): void {
    if (!this.isFormValid())
      return;

    let data = this.modifyBeforeSave(this.formData);

    if (this.id == null)
      this.baseService.create(this.url, data, (response) => {
        this.onSaveSuccessNew(response, true);
      });
    else
      this.baseService.update(this.url, data, (response) => {
        this.onSaveSuccessNew(response, false);
      });
  }

  private onSaveSuccessNew(response, isCreate: boolean): void {
    this.formData = this.modifyResult(response);
    this.initialFormData = { ...this.formData};
    this.pendingChanges = false;

    this.alertService.success('SHARED.SAVE_SUCCESS');
    this.pendingChanges = false;

    if (isCreate) {
      let urlpart = '';
      if (response != null && response.id != null)
        urlpart = `/${response.id}`;
      this.router.navigateByUrl(this.router.url.split('/')[1] + urlpart);
    }
  }

  private modifyBeforeSave(formData: Badge) {
    let data = {...formData};
    data.image = (<any>data.image).path;
    return data;
  }
  
  isFileUploadDisabled(): boolean {
    return (this.formData.mnemonic == null || this.formData.mnemonic == '') || (this.formData.name == null || this.formData.name =='');
  }
}
